import _ from "lodash";
import React from "react";
import styled from "styled-components";

import { Text } from "@components/Text";
import { COLOR_GREY, COLOR_GREY_1 } from "@static/COLORS";
import { convertFormatDate } from "@utils/convertFormatDate";

const Container = styled.div`
  width: 300px;
`;

const Line = styled.div`
  width: 100%;
  height: 1px;
  background: ${COLOR_GREY_1};
  margin: 4px 0px;
`;

export const ContentInfo = ({ data }) => {
  const type = _.get(data, ["type"]);
  const deviceMaster = _.get(data, ["deviceMaster", "name"]);

  return (
    <Container>
      <Text fontWeight="500">Device Master</Text>
      <Text>{deviceMaster}</Text>
      <Line />
      <Text>Slave</Text>
      {_.chain(data)
        .get(["deviceGroupsDetails"])
        .uniqBy("device_id")
        .filter((item, index) => {
          return _.get(item, ["device_id"]) !== _.get(data, ["device_master"]);
        })
        .map((item, index) => {
          return <Text key={index}>{_.get(item, ["device", "name"])}</Text>;
        })
        .value()}
    </Container>
  );
};
